<template>
  <div class="zhuanshudingding">
    <div class="banner"></div>
    <!-- 定制工作台 -->
    <div class="cont2-s">
      <p>钉钉定制版工作台</p>
      <div class="line"><div class="line2"></div></div>
      <div class="title">让每个企业都可以拥有自己的专属工作门户</div>
      <div class="title">助力实现企业数字化智能工作方式升级</div>
    </div>
    <!-- 什么是工作台 -->
    <div class="work">
      <p>什么是定制版工作台？</p>
      <ul>
        定制工作台是基于钉钉工作台的开放能力，借助定制服务商的设计和交付服务，为客户在工作台中进行布局样式的专属设计和搭建，将钉钉工作台打造成千行千面、千人千面的组织专属工作台和数字化协同终端，从而达到企业品牌建设、文化宣传、业务运营等目的。客户可以根据自己的需求，对工作台中的布局、排版、图标等诸多设计元素进行百分百的定制化设计，并通过服务商来进行答疑、设计、交付等服务。
      </ul>
    </div>
    <div class="img">
      <img src="./img-info/img-dingzhi-s1-tuya.png" alt="">
    </div>
    <!-- 钉钉六大功能 -->
    <div class="fuct">
      <p>钉钉定制工作台6大功能</p>
      <div class="small">轻松实现企业数字化，协同效率大大提升</div>
      <div class="content">
          <div class="item">
              <div class="top">统一安全</div>
              <div class="buttom">基于钉钉工作台底座搭建和部署，保障门户绝对安全性和可靠性。</div>
          </div>
          <div class="item">
              <div class="top">统一体验</div>
              <div class="buttom">与钉钉官方客户端一样严格的组件规范，基于小程序框架，保证优质体验。</div>
          </div>
          <div class="item">
              <div class="top">统一服务</div>
              <div class="buttom">全线上服务流程，从客户发起定制到服务商承接定制全链路保障</div>
          </div>
          <div class="item">
              <div class="top">千行千面</div>
              <div class="buttom">钉钉深厚的企业服务能力，构建教育/ 政务/影视/党建/电商/会务等行业专属业务门户。</div>
          </div>
          <div class="item">
              <div class="top">千人千面</div>
              <div class="buttom">基于钉钉组织协同能力，不同角色用户可以拥有专属服务门户页面授权，实现业务协同。</div>
          </div>
          <div class="item">
              <div class="top">生态在线</div>
              <div class="buttom">丰富的生态化市场，提供高价值门户方案和生态组件快速集成，真正实现业务在线。</div>
          </div>
          
      </div>
    </div>
    <!-- 高级版差异 -->
    <div class="cont1-s">
      <div class="content">
        <div class="title">高级版 / 定制版工作台功能差异</div>
        <!-- :cell-style="top" -->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :cell-style="{ borderColor: '#C0C0C0' }"
          :header-cell-style="{ borderColor: '#C0C0C0' }"
        >
          <el-table-column prop="date" label="" width="412"> </el-table-column>
          <el-table-column prop="name" label="高级版" width="412">
          </el-table-column>
          <el-table-column prop="address" label="定制版"> </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 模板中心 -->
    <div class="cont1">
      <div class="content">
        <div class="title">模板中心</div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s2-tuya.jpg" alt="">
        </div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s3-tuya.jpg" alt="">
        </div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s4-tuya.jpg" alt="">
        </div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s5-tuya.jpg" alt="">
        </div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s6-tuya.jpg" alt="">
        </div>
        <div class="item">
          <img src="./img-info/img-dingzhi-s7-tuya.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="cont2">
      <div class="zhuanjia">
        <p class="bushuzhuanjia">部署专家免费服务</p>
        <p class="zhuanjiafuwu">
          <span>联系部署专家：</span
          >根据您提交的需求，将有钉钉部署专家免费为您服务！
        </p>
        <div class="btn-zixun" @click="jumpZX">立即咨询</div>
      </div>
      <div class="sssdd"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: "试用期时长",
          name: "7天",
          address: "30天",
        },
        {
          date: "组织人数限制",
          name: "不受限",
          address: "阶梯受限",
        },
        {
          date: "自定义组件",
          name: "不支持",
          address: "支持",
        },
        {
          date: "第三方数据",
          name: "不支持",
          address: "支持",
        },
        {
          date: "隐藏推广模块",
          name: "不支持",
          address: "支持（OA审批）",
        },
        {
          date: "开放范围",
          name: "定向开放，需联系钉钉运营小二申请开通，开通后下单时可见该规格",
          address: "面向定制服务商开放，需要满足工作台服务商条件",
        },
      ],
    };
  },
  methods: {
    jumpZX() {
                  window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

    },
    // 改变某一列单元格背景颜色
    top({ row, column, rowIndex, columnIndex }) {
      console.log(row.taskColor, "-->row.taskColor");
      let rowBackground = {};
      if (row.taskColor) {
        if (columnIndex === 2) {
          rowBackground.background = row.taskColor;
        } else {
          rowBackground.background = "white";
        }
      } else {
        rowBackground.background = "red";
      }
      return rowBackground;
    },
  },
};
</script>
<style lang='less' scoped>
.zhuanshudingding {
  width: 100%;
  text-align: left;
  .banner {
    width: 100%;
    height: 450px;
    background-image: url(./banner-pc-img/jjfa_dzgzt_1920337.5@1x-tuya.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  > .cont2-s {
    width: 80%;
    margin: 35px auto;
    > p {
      width: 100%;
      height: 40px;
      font-size: 35px;
      color: #000;
      text-align: center;
    }
    > .line {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      > .line2 {
        width: 80px;
        height: 4px;
        background-color: rgb(83, 137, 253);
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    > .title {
      width: 100%;
      height: 40px;
      font-size: 26px;
      color: #000;
      text-align: center;
    }
  }
  > .work {
    width: 80%;
    background-color: rgb(103, 142, 252);
    margin: 0 auto;
    border-radius: 10px;
    padding: 50px;
    > p {
      width: 100%;
      height: 37px;
      font-size: 28px;
      color: white;
      text-align: center;
      margin-bottom: 15px;
    }
    > ul {
      font-size: 20px;
      color: white;
      word-wrap: break-word;
      line-height: 35px;
    }
  }
  > .img {
    width: 80%;
    margin: 0 auto;
    background-color: rgb(245, 245, 245);
    text-align: center;
    padding: 40px;
    > img {
      width: 70%;
      height: 700px;
    }
  }
  > .fuct {
    width: 80%;
    margin: 50px auto;
    padding: 50px;
    > p {
        color: #000;
        font-size: 32px;
        text-align: center;
    margin-bottom: 8px;
    }
    >.small{
        font-size: 20px;
        color: #696969;
        width: 100%;
        text-align: center;
        margin-top: 15px;
    }
    >.content{
        margin-top: 50px;
        width: 100%;
        // background-color: red;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 40px;
        padding-top: 0px;
        >.item{
            width: 23%;
            // background-color: green;
            overflow: hidden;
            border-radius: 8px;
            padding: 20px;
            >.top{
                width: 100%;
                padding: 20px 40px;
                text-align: center;
                background-color: rgb(103,142,252);
                color: white;
                font-size: 18px;
            }
            .buttom{
                width: 100%;
                height: 126px;
                background-color: rgb(245, 245, 245);
                color: #000;
                font-size: 16px;
                padding:30px 20px;
            }
        }
    }
  }
  > .cont1-s {
    width: 100%;
    background-color: #f7f7f7;
    > .content {
      width: 80%;
      margin: 0 auto;
      padding: 50px 0;
      box-sizing: border-box;
      > .title {
        width: 100%;
        font-size: 32px;
        color: #000;
        text-align: center;
        margin-bottom: 32px;
        padding: 20px;
      }
    }
  }
  .cont1 {
    width: 100%;
    background-color: #fff;
    padding-bottom: 50px;
    > .content {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      > .title {
        width: 100%;
        height: 36.8px;
        text-align: center;
        font-size: 32px;
        color: #000;
        margin: 35px 0 30px;
      }
      > .item {
        width: 29.7%;
        padding: 30px;
        display: flex;
        justify-content: center;
        > img {
          width: 80%;
          height: 800px;
        }
      }
    }
  }
  .cont2 {
    width: 100%;
    background-color: #fff;
    .zhuanjia{
            width: 80%;
             background-color: rgba(245, 245, 245, 1);
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
    .sssdd {
      height: 40px;
    }
  }
}
/deep/ th.el-table__cell {
  font-size: 18px;
  height: 55px;
  padding: 0;
  font-weight: normal;
  color: white;
}

/deep/ .el-table tr {
  // background-color: red;
  font-size: 16px;
  color: #000;
  padding: 0;
}
/deep/ .el-table th:nth-child(2) {
  background-color: rgb(153, 153, 153) !important;
}
/deep/ .el-table th:nth-child(3) {
  background-color: rgb(103, 142, 252) !important;
}
::v-deep .el-table td:nth-child(2) {
  background-color: rgb(245, 245, 245);
}
::v-deep .el-table td:nth-child(3) {
  background-color: rgb(234, 239, 251);
}
</style>